<template>
  <v-card class="ma-4 pa-4">
    <v-card-title class="text-h5">Descargador de futuros</v-card-title>
    <ComponenteLoading :is-loading="loading" :message="mensaje_loading" />
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-row align="center" class="mb-4">
            <v-col cols="2">
              <VueDatePicker model-type="dd/MM/yyyy" v-model="fecha_inicio" :format="'dd/MM/yyyy'" text-input :teleport="true"  :auto-apply="true"/>
            </v-col>
            <v-col cols="2">
              <VueDatePicker model-type="dd/MM/yyyy" v-model="fecha_fin" :format="'dd/MM/yyyy'" text-input :teleport="true"  :auto-apply="true" />
            </v-col>
            <v-col cols="4">
              <v-btn  class="mr-3" @click="obtener_datos">
                  <span class="material-symbols-outlined">
                  south_west
                  </span>
                Descargar</v-btn>
              <v-btn  @click="exportToExcel">
                 <span class="material-symbols-outlined">csv</span> 
                Exportar</v-btn>
            </v-col>
          </v-row>

          <v-tabs color="black"
          class="gris_suave" v-model="tab">
            <v-tab  value="tab1">OMIP</v-tab>
            <v-tab  value="tab2">MIBGAS</v-tab>
            <v-tab  value="tab3">CO2</v-tab>
          </v-tabs>

          <v-window v-model="tab">
            <v-window-item value="tab1" class="mt-2">
              <v-div id="mi-clase-personalizada">
                <v-grid theme="material" :source="data_omip" :columns="headers_omip" canFocus range useClipboard filter resize
                row-class="rowClass"  style="min-height: 60vh; " />
              </v-div>
            </v-window-item>
            <v-window-item value="tab2" class="mt-2">
              <v-div id="mi-clase-personalizada">
                <v-grid theme="material" :source="data_mibgas" :columns="headers_mibgas" canFocus range useClipboard filter resize
                row-class="rowClass" style="min-height: 60vh; max-width: 1500px;" />
              </v-div>
            </v-window-item>
            <v-window-item value="tab3" class="mt-2">
              <v-div id="mi-clase-personalizada">
                <v-grid theme="material" :source="data_co2" :columns="headers_co2" canFocus range useClipboard filter resize 
                row-class="rowClass" style="min-height: 60vh;max-width: 2250px; " />
              </v-div>
            </v-window-item>
          </v-window>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
  <v-dialog v-model="showAlert" max-width="400">
      <v-card>
        <v-card-title class="headline">⚠️ Atención</v-card-title>
        <v-card-text>{{ error_msg }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showAlert = false; error_msg=''">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import VGrid from "@revolist/vue3-datagrid";
import * as XLSX from 'xlsx';
import ComponenteLoading from "../ComponenteLoading.vue";
import store from "../../store";
import axios from "axios";

export default {
  components: {
    VGrid,
    ComponenteLoading,
  },
  data() {
    return {


      loading: false,
      mensaje_loading: "",

      fecha_inicio: new Date(new Date().setDate(new Date().getDate() - 7)).toLocaleDateString('es-ES', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      }),

      fecha_fin: new Date().toLocaleDateString('es-ES', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      }),


      tab: "tab1",

      headers_omip: [],
      data_omip: [],
      
      headers_mibgas: [],
      data_mibgas: [],
      
      headers_co2: [],
      data_co2: [],
      showAlert:false,
      error_msg:"",      

    };
  },
  methods: {

    convertirFecha(fecha) {
        let partes = fecha.split('/'); // Divide "DD/MM/YYYY" en ["DD", "MM", "YYYY"]
        return `${partes[2]}-${partes[1]}-${partes[0]}`; // Rearma en "YYYY-MM-DD"
    },



    obtener_datos(){
                
        let fecha_inicio_api = this.convertirFecha(this.fecha_inicio)
        let fecha_fin_api =  this.convertirFecha(this.fecha_fin)

          this.loading = true;
          this.mensaje_loading = "Descargando datos..."
          axios(
              {
                  method: 'get',
                  url: process.env.VUE_APP_API_BASE_URL + '/api/descargador-futuros?start_date=' + fecha_inicio_api + '&end_date=' + fecha_fin_api,    
                  withCredentials: true,                   
                  headers: { 
                    Authorization: "Bearer " + store.state.token,
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json'                
                  },      
              }
          )
          .then((response) => {                  
              let myObject = response.data;
              if (myObject && typeof myObject === 'object') {
                console.log("Es un objecto")
                console.log(typeof myObject);
              }else{
                console.log("NO Es un objecto")
                console.log(typeof myObject);
                myObject=JSON.parse(myObject);
              }
              //console.log("Respuesta: ", Object.keys(myObject))
              //console.log("Objecto: ", myObject)
              this.data_omip = myObject['omip']['data'];    
              this.data_omip = this.data_omip.map(item => ({
                ...item,
                rowClass: "ClaseRow"
              }));  
              this.headers_omip = myObject['omip']['headers'];     

              this.data_mibgas = myObject['mibgas']['data'];  
              this.data_mibgas = this.data_mibgas.map(item => ({
                ...item,
                rowClass: "ClaseRow"
              }));    
              this.headers_mibgas = myObject['mibgas']['headers'];     

              this.data_co2 = myObject['co2']['data'];     
              this.data_co2 = this.data_co2.map(item => ({
                ...item,
                rowClass: "ClaseRow"
              })); 
              this.headers_co2 = myObject['co2']['headers'];     

              this.loading = false;     
          })



      },
      exportToExcel() {
        if(this.data_omip.length>0){
            const wb = XLSX.utils.book_new();
            const headerOmip = this.headers_omip.map(header => header.name);
            const headerMibGas = this.headers_mibgas.map(header => header.name);
            const headerCo2 = this.headers_co2.map(header => header.name);
            // Crear las cabeceras con los títulos correctos
            let filteredItemsOmip = this.data_omip.map(item => {
              let filteredItem = {};
              headerOmip.forEach(header => {
                // Solo incluir el valor del item que coincida con el 'value' de 'header'
                filteredItem[header] = item[header];
              });
              return filteredItem;
            });

            let filteredItemsMibGas = this.data_mibgas.map(item => {
              let filteredItem = {};
              headerMibGas.forEach(header => {
                // Solo incluir el valor del item que coincida con el 'value' de 'header'
                filteredItem[header] = item[header];
              });
              return filteredItem;
            });


            let filteredItemsCo2 = this.data_co2.map(item => {
              let filteredItem = {};
              headerCo2.forEach(header => {
                // Solo incluir el valor del item que coincida con el 'value' de 'header'
                filteredItem[header] = item[header];
              });
              return filteredItem;
            });


           // Crear hoja de cálculo con los datos filtrados
            const ws1 = XLSX.utils.json_to_sheet(filteredItemsOmip, { header: this.headers_omip.map(header=> header.name) });
            const ws2 = XLSX.utils.json_to_sheet(filteredItemsMibGas, { header: this.headers_mibgas.map(header=> header.name) });
            const ws3 = XLSX.utils.json_to_sheet(filteredItemsCo2, { header: this.headers_co2.map(header=> header.name) });
            // Añadir las hojas de trabajo al libro
            XLSX.utils.book_append_sheet(wb, ws1, 'Futuros Omip');
            XLSX.utils.book_append_sheet(wb, ws2, 'Futuros MibGas');
            XLSX.utils.book_append_sheet(wb, ws3, 'Futuros Co2');

            // Exportar el libro a un archivo Excel
            XLSX.writeFile(wb, 'Futuros.xlsx');

          }
          else{
            console.log("Datos vacíos")
            this.error_msg="Descarga los precios antes de exportarlos";
            this.showAlert=true;
          }
        }


    
  },
};
</script>

<style scoped>
 /* Estilo hover, similar a las otras tablas sin v-grid */
::v-deep(.ClaseRow:hover){
    background-color: #e6f2f6 !important; 
  border-left: 2px solid #1776BF !important;
}

/* Estilo para las cabeceras, similar a las tablas sin v-grid */
::v-deep(.rgHeaderCell) {
     background-color: #f2f2f2 !important;
    color: #282828 !important;
    padding: 5px !important;
    min-width: 100px !important;
     font-weight: bold;
     text-align: center !important;
    
    
}
/* Estilo redondeado para la tabla, similar a las tablas sin v-grid */
#mi-clase-personalizada ::v-deep(.main-viewport) {
  border-radius: 20px;
  overflow: hidden; /* importante para que no se vean las esquinas cuadradas internas */
 
}
/* Estilo para la columna de Fecha, similar a las tablas sin v-grid */
::v-deep([data-rgcol="0"]) {
  font-weight: bold !important;
}

</style>
